<template>
  <article>
    <el-col
      :sm="24"
      :md="12"
      :lg="8"
      :xl="8"
      class="news-card-col"
    >
      <el-card class="news-card box-card text-center">
        <div class="news-img">
          <el-image
            :src="imageForArticle"
            fit="cover"
          ></el-image>
        </div>
        <div class="title-position">
          <h2 class="text-truncate">
            {{ article.title }}
          </h2>
          <p
            class="text-truncate mt-4"
            v-html="content"
          ></p>
        </div>
        <div class="read-more-btn-container">
          <el-button
            type="primary"
            class="read-more-btn"
            @click="readMore(article.id)"
          >
            Read more <span class="sr-only">about {{ article.title }}</span>
          </el-button>
        </div>
      </el-card>
    </el-col>
  </article>
</template>

<script>
export default {
  name: "NewsCard",
  components: {},
  props: {
    article: {
      type: Object,
      required: true
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      articleTypes: {
        news: "News",
        spotlight: "Spotlight",
        feature: "Feature",
        event: "Event",
        casestudy: "Case Study"
      }
    };
  },
  computed: {
    imageForArticle() {
      return this.article.has_feature_image
        ? this.article.feature_image.url
        : null;
    },
    content(){
      return this.article?.content?.length ? this.article.content[0].text : ''
    },
  },
  methods: {
    readMore(id) {
      this.$router.push({ name: "News", params: { id } });
    }
  }
};
</script>
